module.exports = __webpack_public_path__ + "static/media/IlotC_synthese_3.34678619.webp";